<template>
  <div>
    <div class="d-flex align-items-center justify-content-between">
      <div :class="['section-title', { active: isActive }]">
        <h3>
          {{
            pageType === "change-name"
              ? "Daftar Unit yang dialihkan ke Lessee Target"
              : "Pilih Unit yang dialihkan ke Lessee Target"
          }}
        </h3>
      </div>
      <!-- <ToggleSwitch
        v-if="
          isActive &&
          getFormData.units.length > 0 &&
          pageType === 'transfer-unit'
        "
        :value="getFormData.transferAllUnits"
        label="Alihkan Semua Unit ke Lessee Target"
        @change="setTransferAllUnits()"
        :disabled="
          disabledInput ||
          getFormData.units.length === 0 ||
          pageType === 'change-name'
        "
      /> -->
    </div>
    <div v-if="isActive" class="choose-unit">
      <div class="form-container">
        <!-- Start Info Box -->
        <div class="blue-info-box mt-2">
          <div>
            <img src="@/assets/icon/warning-circle-blue.svg" alt="warning" />
          </div>
          <p class="label">
            {{ infoBoxText }}
          </p>
        </div>
        <!-- End Info Box -->

        <!-- Units Table -->
        <div class="units-grid">
          <!-- Header -->
          <div class="units-grid__header">
            <div class="col-expand"></div>

            <div class="col-checkbox">
              <div
                style="width: 18px"
                class="d-flex align-items-center justify-content-center"
              >
                <input
                  class="checkbox-input"
                  type="checkbox"
                  :disabled="transferAllUnits || disabledInput"
                  :checked="allUnitsSelected"
                  @change="toggleUnitSelected($event.target.checked)"
                />
              </div>
            </div>

            <div class="col-order">DATA ORDER AWAL</div>

            <div class="col-target">TARGET PENGALIHAN UNIT</div>

            <div class="col-start">START RENT</div>

            <div class="col-end">END RENT</div>
          </div>

          <!-- Not Found Units -->
          <div v-if="units.length === 0" class="p-2 text-center">
            <p class="m-0">Tidak ada unit yang ditemukan.</p>
          </div>

          <!-- Rows -->
          <div v-for="(unit, unitIndex) in getFormData.units" :key="unitIndex">
            <!-- SECTION - Order Level Row -->
            <div
              class="units-grid__row"
              :class="[
                {
                  'border-b-none': unit.errMessage,
                  'child-error': unit.errMessage,
                },
              ]"
            >
              <div class="col-expand">
                <span
                  v-if="unit.children && unit.children.length > 0"
                  class="expand-icon d-flex align-items-start justify-content-center"
                  @click="toggleUnitExpanded(unitIndex)"
                >
                  <div :class="[{ open: !unit.expanded }]">
                    <i class="fa fa-chevron-up" />
                  </div>
                </span>
              </div>

              <div class="col-checkbox">
                <div
                  style="width: 18px"
                  class="d-flex align-items-start justify-content-center"
                >
                  <input
                    class="checkbox-input"
                    type="checkbox"
                    :checked="unit.selected"
                    :disabled="
                      transferAllUnits ||
                      disabledInput ||
                      unit.isAllUnitUnavailable
                    "
                    @change="
                      updateUnitField(
                        unitIndex,
                        'selected',
                        $event.target.checked
                      )
                    "
                  />
                </div>
              </div>

              <div
                class="col-order"
                :style="{
                  paddingBottom: Boolean(unit.errMessage) ? '0' : '12px',
                }"
              >
                <router-link
                  :to="`/order/detail/${unit.orderId}?orderCode=${unit.orderCode}`"
                  :target="'_blank'"
                  class="order-link"
                >
                  <p class="m-0">{{ unit.orderCode }}</p>
                  <p v-if="unit.batch" class="m-0">Batch({{ unit.batch }})</p>
                </router-link>
              </div>

              <div class="col-target">
                <component
                  :is="
                    rentAdjustmentStatus === 'executed' ? 'router-link' : 'div'
                  "
                  :to="
                    rentAdjustmentStatus === 'executed'
                      ? `/order/detail/${unit.targetUnit.orderId}?orderCode=${unit.targetUnit.orderCode}`
                      : undefined
                  "
                  :target="
                    rentAdjustmentStatus === 'executed' ? '_blank' : undefined
                  "
                  style="text-decoration: none"
                >
                  <OrderCodeDropdown
                    :value="orderCodeTargetValue(unit.children)"
                    :disabled="
                      !unit.selected ||
                      transferAllUnits ||
                      disabledInput ||
                      unit.isAllUnitUnavailable
                    "
                    :isMultiple="isMultipleOrderCodeTarget(unit.children)"
                    :options="handleParseOrderCodeOptions(unit)"
                    @change="
                      updateUnitField(
                        unitIndex,
                        'targetUnit',
                        $event,
                        unit.children
                      )
                    "
                  />
                </component>
              </div>

              <div class="col-start">
                <div class="d-flex align-items-center pl-3" style="gap: 8px">
                  <p class="m-0 rent-date">
                    {{ convertToIndonesiaDate(unit.startRent) }}
                  </p>

                  <img src="~@/assets/icon/mdi_calendar.svg" />
                </div>
              </div>

              <div class="col-end">
                <div class="d-flex align-items-center pl-3" style="gap: 8px">
                  <p class="m-0 rent-date">
                    {{ convertToIndonesiaDate(unit.endRent) }}
                  </p>

                  <img src="~@/assets/icon/mdi_calendar.svg" />
                </div>
              </div>
            </div>
            <div
              v-if="unit.errMessage"
              class="units-grid__row child-row child-error"
            >
              <div class="col-expand"></div>

              <div class="col-checkbox"></div>

              <div class="col-order"></div>

              <div
                class="col-target"
                style="grid-column: span 3; padding: 0; padding-top: 0"
              >
                <div class="units-grid__error-row">
                  <div class="error-message">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <circle
                        cx="8"
                        cy="8"
                        r="7"
                        stroke="#973C00"
                        stroke-width="1.5"
                      />
                      <text
                        x="8"
                        y="11"
                        text-anchor="middle"
                        font-size="10"
                        fill="#973C00"
                      >
                        !
                      </text>
                    </svg>

                    {{ unit.errMessage }}
                  </div>
                </div>
              </div>
            </div>
            <!-- SECTION - Units Level Row -->
            <template v-if="unit.expanded && unit.children">
              <div
                v-for="(child, childIndex) in unit.children"
                :key="`${unitIndex}-${childIndex}`"
              >
                <div
                  class="units-grid__row child-row"
                  :class="[{ 'child-error': Boolean(child.errMessage) }]"
                  :style="{
                    borderBottom: Boolean(child.errMessage) ? 'none' : null,
                  }"
                >
                  <div class="col-expand"></div>

                  <div class="col-checkbox">
                    <div
                      style="width: 18px"
                      class="d-flex align-items-start justify-content-center"
                    >
                      <input
                        class="checkbox-input"
                        type="checkbox"
                        :checked="child.selected"
                        :disabled="
                          Boolean(child.errMessage) ||
                          transferAllUnits ||
                          disabledInput
                        "
                        @change="
                          updateChildUnitField(
                            unitIndex,
                            childIndex,
                            'selected',
                            $event.target.checked
                          )
                        "
                      />
                    </div>
                  </div>

                  <div class="col-order">
                    <p :href="`#${child.orderAwal}`" class="order-child-code">
                      {{ child.orderCode
                      }}{{
                        child.serialNumber ? ` / ${child.serialNumber}` : ""
                      }}
                    </p>
                  </div>

                  <div class="col-target">
                    <OrderCodeDropdown
                      :value="child.targetUnit"
                      :disabled="
                        !child.selected || transferAllUnits || disabledInput
                      "
                      :options="handleParseOrderCodeOptions(child)"
                      @change="
                        updateChildUnitField(
                          unitIndex,
                          childIndex,
                          'targetUnit',
                          $event
                        )
                      "
                    />
                  </div>

                  <div class="col-start">
                    <div
                      class="d-flex align-items-center pl-3"
                      style="gap: 8px"
                    >
                      <p class="m-0 rent-date">
                        {{ convertToIndonesiaDate(child.startRent) }}
                      </p>

                      <img src="~@/assets/icon/mdi_calendar.svg" />
                    </div>
                  </div>

                  <div class="col-end">
                    <div
                      class="d-flex align-items-center pl-3"
                      style="gap: 8px"
                    >
                      <p class="m-0 rent-date">
                        {{ convertToIndonesiaDate(child.endRent) }}
                      </p>

                      <img src="~@/assets/icon/mdi_calendar.svg" />
                    </div>
                  </div>
                </div>
                <div
                  v-if="Boolean(child.errMessage)"
                  class="units-grid__row child-row child-error"
                >
                  <div class="col-expand"></div>

                  <div class="col-checkbox"></div>

                  <div class="col-order"></div>

                  <div
                    class="col-target"
                    style="grid-column: span 3; padding: 0; padding-top: 0"
                  >
                    <div class="units-grid__error-row">
                      <div class="error-message">
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <circle
                            cx="8"
                            cy="8"
                            r="7"
                            stroke="#973C00"
                            stroke-width="1.5"
                          />
                          <text
                            x="8"
                            y="11"
                            text-anchor="middle"
                            font-size="10"
                            fill="#973C00"
                          >
                            !
                          </text>
                        </svg>

                        {{ child.errMessage }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>

        <!-- Deposit Question -->
        <div
          class="deposit-section"
          :style="{ width: depositTransfer === true ? 'fit-content' : '100%' }"
        >
          <div style="width: 400px">
            <InputRadio
              name="depositTransfer"
              label="Apakah ada pengalihan deposit ke lessee target?"
              type="horizontal"
              styleType="button"
              :value="depositTransfer"
              :disabled="disabledInput"
              :options="[
                { label: 'Ya', value: true },
                { label: 'Tidak', value: false },
              ]"
              @change="setDepositTransfer($event)"
            />
          </div>
          <template v-if="depositTransfer === false">
            <br />
            <InputTextarea
              id="reasonNoDepositTransfer"
              label="Alasan"
              :value="getFormData.reasonNoDepositTransfer"
              placeholder="Alasan tidak ada pengalihan deposit ke lessee target"
              :rows="3"
              :disabled="disabledInput"
              @change="setReasonNoDepositTransfer($event)"
            />
          </template>
        </div>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import { InputRadio, ToggleSwitch, InputTextarea } from "@/components/Input";
import { mapGetters, mapMutations } from "vuex";
import OrderCodeDropdown from "@/components/RentAdjustment/CustomComponent/OrderCodeDropdown";
import { alert } from "@/utils";
import mixin from "@/components/RentAdjustment/mixin";

export default {
  name: "ChooseUnit",
  components: {
    InputRadio,
    ToggleSwitch,
    OrderCodeDropdown,
    InputTextarea,
  },
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [mixin],
  data() {
    return {};
  },
  computed: {
    ...mapGetters("rentAdjustment", {
      currentStep: "getCurrentStep",
      getFormData: "getFormData",
      orderCodeOptions: "getTargetUnitOptions",
      transferUnitStatus: "getStatus",
      transferUnitId: "getId",
      disabledNotDraft: "getDisabledNotDraft",
      units: "getUnits",
      depositTransfer: "getDepositTransfer",
      transferAllUnits: "getTransferAllUnits",
      pageType: "getType",
    }),
    allUnitsSelected() {
      if (this.getFormData.units.length === 0) return false;
      return this.units
        .filter((unit) => !unit.isAllUnitUnavailable)
        .every((unit) => unit.selected);
    },
    infoBoxText() {
      if (!this.transferUnitStatus || this.transferUnitStatus === "draft") {
        return "Unit-unit yang tertera adalah seluruh aset sewa aktif milik Lessee Awal yang akan dialihkan secara massal ke nama Lessee Target.";
      }
      return "Unit-unit yang tertera di bawah ini adalah unit yang telah berhasil dipilih untuk dialihkan ke Lessee Target.";
    },
  },
  methods: {
    ...mapMutations("rentAdjustment", {
      setTransferAllUnits: "SET_TRANSFER_ALL_UNITS",
      setDepositTransfer: "SET_DEPOSIT_TRANSFER",
      setReasonNoDepositTransfer: "SET_REASON_NO_DEPOSIT_TRANSFER",
      setUnitField: "SET_UNIT_FIELD",
      setChildUnitField: "SET_CHILD_UNIT_FIELD",
      toggleUnitExpanded: "TOGGLE_UNIT_EXPANDED",
      toggleUnitSelected: "TOGGLE_UNIT_SELECTED",
    }),
    orderCodeTargetValue(children) {
      const defaultTargetUnit = {
        orderId: 0,
        orderCode: "",
        batch: "",
        isNew: false,
      };
      const isChildOrderCodeTargetSame =
        this.isChildOrderCodeTargetSame(children);
      if (isChildOrderCodeTargetSame) {
        const childrenWithoutError = children.filter(
          (child) =>
            !Boolean(child.errMessage) && child.targetUnit.orderId !== 0
        );
        if (childrenWithoutError.length > 0) {
          return childrenWithoutError[0].targetUnit;
        }
        return defaultTargetUnit;
      }
      return defaultTargetUnit;
    },
    isMultipleOrderCodeTarget(children) {
      return !this.isChildOrderCodeTargetSame(children);
    },
    isChildOrderCodeTargetSame(children) {
      if (!children || children.length === 0) return true;
      const childrenWithoutError = children.filter(
        (child) => !Boolean(child.errMessage) && child.targetUnit.orderId !== 0
      );
      if (childrenWithoutError.length === 0) return true;
      return childrenWithoutError.every(
        (child) =>
          child.targetUnit.orderId ===
          childrenWithoutError[0].targetUnit.orderId
      );
    },
    /**
     *
     * @param type - type of order code options, can be 'parent' or 'child'
     *
     * This function is very complicated because to achive the criteria of
     * order code options can be selected by batch in order from lowest to highest
     *
     * this function is suck because the design is suck, I create this function
     * because i have to follow the fucked up design and flow that haven't considered before,
     * for next dev that change this code, i hope you understand this function
     */
    /**NOTE
     * THIS FUNCTION IS CHANGED SINCE SPRINT 13, 9-17-2026
     * BECAUSE Child can select current batch or 1 batch ahead
     * if current available batch is already selected by other parent/child
     */
    handleParseOrderCodeOptions(currentUnit) {
      /** NOTE
       *  Criteria when choosing order code options:
       *
       * - if user hasn't selected any unit, only the first batch will be active
       * - if user has selected a unit, the one batch ahead of the selected unit will be active
       * - next batch will be active if the current selected batch is already selected by other unit
       */
      const units = this.getFormData.units;
      const sortedOrderCodeOptions = [...this.orderCodeOptions].sort((a, b) => {
        return a.value.batch - b.value.batch;
      });

      let hasSelectedBatch = false;

      for (const unit of units) {
        if (unit.targetUnit && unit.targetUnit.orderCode) {
          hasSelectedBatch = true;
          break;
        }
        for (const child of unit.children) {
          if (child.targetUnit && child.targetUnit.orderCode) {
            hasSelectedBatch = true;
            break;
          }
        }
      }

      if (!hasSelectedBatch) {
        return sortedOrderCodeOptions.map((option, index) => {
          return {
            label: option.label,
            value: option.value,
            disabled: index === 0 ? false : true,
          };
        });
      }

      /** NOTE
       * This code below is used to handle condition:
       *   - all Options will disabled except current selected batch if current selected
       *   batch is in between first selected batch and last selected batch,
       *   - this is to prevent user from selecting other batch because it will cause
       *   batch jump and break the flow of batch selection
       *
       * @constant totalCurrentUnitSelectedBatch - total target order is selected by other unit/order awal
       *
       */

      const totalCurrentUnitSelectedBatch = units.reduce((acc, unit) => {
        unit.children.forEach((child) => {
          if (
            child.selected &&
            child.targetUnit &&
            child.targetUnit.orderCode &&
            child.targetUnit.batch === currentUnit.targetUnit.batch
          ) {
            acc++;
          }
        });
        return acc;
      }, 0);

      if (totalCurrentUnitSelectedBatch === 1) {
        let anySelectedBatchAboveCurrentBatch = false;

        for (const unit of units) {
          if (
            unit.selected &&
            unit.targetUnit &&
            unit.targetUnit.orderCode &&
            unit.targetUnit.batch > currentUnit.targetUnit.batch
          ) {
            anySelectedBatchAboveCurrentBatch = true;
            break;
          }
          for (const child of unit.children) {
            if (
              child.selected &&
              child.targetUnit &&
              child.targetUnit.orderCode &&
              child.targetUnit.batch > currentUnit.targetUnit.batch
            ) {
              anySelectedBatchAboveCurrentBatch = true;
              break;
            }
          }
        }

        return sortedOrderCodeOptions.map((option) => {
          let disabledBatch = option.value.batch > currentUnit.targetUnit.batch;
          if (anySelectedBatchAboveCurrentBatch) {
            disabledBatch = option.value.batch !== currentUnit.targetUnit.batch;
          }
          return {
            label: option.label,
            value: option.value,
            disabled: disabledBatch,
          };
        });
      }

      const maxSelectedBatch = units.reduce((acc, unit) => {
        if (
          unit.selected &&
          unit.targetUnit &&
          unit.targetUnit.orderCode &&
          unit.targetUnit.batch > acc
        ) {
          acc = unit.targetUnit.batch;
        }
        unit.children.forEach((child) => {
          if (
            child.selected &&
            child.targetUnit &&
            child.targetUnit.orderCode &&
            child.targetUnit.batch > acc
          ) {
            acc = child.targetUnit.batch;
          }
        });
        return acc;
      }, 0);

      return sortedOrderCodeOptions.map((option) => {
        return {
          label: option.label,
          value: option.value,
          disabled: option.value.batch > maxSelectedBatch + 1,
        };
      });

      /**NOTE
       * CODE BELOW IS NOT USED SINCE SPRINT 13, 9-17-2026
       * BECAUSE Child can select current batch or 1 batch ahead
       * if current available batch is already selected by other parent/child
       *
       * i kept this code because of inconsistency in decission making while developing "Pembaruan order"
       * maybe this code will be used in the future, but for now, this code is not used
       */

      let maxEnableBatch = 0;

      units.forEach((unit) => {
        if (unit.selected && unit.targetUnit && unit.targetUnit.orderCode) {
          const currentTargetUnitPosition = sortedOrderCodeOptions.findIndex(
            (option) => option.value.orderId === unit.targetUnit.orderId
          );

          /** NOTE:
           * ------ NO USE Since Sprint 13, 9-17-2026
           * Child can only select the same batch as the parent or
           * other batch if it already selected by other parent,
           * ------
           *
           * while parent can select batch or 1 batch ahead if current available
           * batch is already selected by other parent
           *
           * In condition below, I add a condition for parent if current focus parent
           * already has target Unit, this parent can't select 1 batch ahead,
           * this fix bug that cause user can "jump select" 1 batch ahead
           */
          const currentOrderCodeOption =
            sortedOrderCodeOptions[currentTargetUnitPosition + 1];
          if (
            currentOrderCodeOption &&
            currentOrderCodeOption.value.batch > maxEnableBatch
          ) {
            maxEnableBatch = currentOrderCodeOption.value.batch;
          }
        }
      });

      return sortedOrderCodeOptions.map((option) => {
        return {
          label: option.label,
          value: option.value,
          disabled: option.value.batch > maxEnableBatch,
        };
      });
    },
    convertToIndonesiaDate(dateStr) {
      if (!dateStr) return "";

      const monthsID = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ];

      const [year, month, day] = dateStr.split("-");

      const monthName = monthsID[parseInt(month) - 1];

      return `${parseInt(day)} ${monthName} ${year}`;
    },
    async updateUnitField(index, field, value, children) {
      if (
        field === "targetUnit" &&
        children &&
        children.length > 0 &&
        this.isMultipleOrderCodeTarget(children)
      ) {
        const lpWithDifferentTargetUnit = children.reduce((acc, child) => {
          if (
            !child.errMessage &&
            child.targetUnit.orderId !== 0 &&
            child.targetUnit.orderId !== value.orderId
          ) {
            acc++;
          }
          return acc;
        }, 0);
        if (lpWithDifferentTargetUnit > 0) {
          const alertResponse = await alert().fire({
            title: "Apakah kamu yakin?",
            text: `${lpWithDifferentTargetUnit} unit sudah diatur sebelumnya akan ikut berubah ke ${value.orderCode} (Batch ${value.batch}).`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, Lanjutkan",
            cancelButtonText: "Batal",
          });
          if (!alertResponse.isConfirmed) {
            return;
          }
        }
      }
      this.setUnitField({ index, field, value });
    },
    updateChildUnitField(unitIndex, childIndex, field, value) {
      this.setChildUnitField({ unitIndex, childIndex, field, value });
    },
  },
};
</script>

<style scoped>
.section-title {
  flex: 1;
}

.section-title h3 {
  font-size: 16px;
  font-weight: 600;
  color: #2e3646;
  opacity: 0.4;
  text-transform: capitalize;
  margin-bottom: 12px;
}

.section-title.active h3 {
  opacity: 1;
}

.choose-unit {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-container {
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.header-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding-bottom: 16px;
  border-bottom: 1px solid #d1d9e2;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #2e3646;
  margin: 0;
}

.toggle-switch {
  display: flex;
  align-items: center;
  gap: 8px;
}

.toggle-switch input[type="checkbox"] {
  width: 40px;
  height: 24px;
  cursor: pointer;
  accent-color: #247fec;
}

.toggle-switch label {
  font-size: 14px;
  font-weight: 400;
  color: #2e3646;
  cursor: pointer;
  white-space: nowrap;
}

.units-grid {
  width: 100%;
  border: 1px solid #d1d9e2;
  border-radius: 8px;
}

.units-grid__header,
.units-grid__row {
  display: grid;
  grid-template-columns:
    4%
    4%
    20%
    35%
    19%
    19%;

  align-items: center;
}

.units-grid__header {
  background: #f8f9fa;
  border-bottom: 1px solid #d1d9e2;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.units-grid__header > div {
  padding: 12px 16px;
  font-weight: 600;
  color: #6a7282;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.units-grid__row {
  border-bottom: 1px solid #d1d9e2;
}

.units-grid__row > div {
  padding: 12px 16px;
  padding-left: 0;
}

.units-table-wrapper {
  overflow-x: auto;
}

.col-expand {
  display: flex;
  justify-content: center;
  padding-left: 20px !important;
}

.col-checkbox {
  display: flex;
  justify-content: center;
  padding-left: 10px !important;
}

.col-order,
.col-target,
.col-start,
.col-end {
  min-width: 0;
}

@media (max-width: 1200px) {
  .units-grid {
    min-width: 1100px;
  }
}

.col-checkbox input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #247fec;
}

.expand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
  font-size: 12px;
  color: #4a5565;
  user-select: none;
}

.expand-icon > div {
  transition: transform 0.3s ease;
}

.expand-icon > div.open {
  transform: rotate(180deg);
}

.order-link {
  color: #247fec;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  word-break: break-word;
}

.col-order .order-child-code {
  color: #38485c;
  text-decoration: none;
  font-weight: 500;
  font-size: 16px;
  word-break: break-word;
  margin: 0;
}

.units-grid__error-row {
  padding: 0;
  padding-bottom: 10px;
}

.child-error-row {
  padding-left: 80px;
}

.child-row {
  border: none;
  border-bottom: 1px solid #d1d9e2;
}

.child-error {
  background: #fffbf5;
}

.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #973c00;
  font-size: 14px;
}

.deposit-section {
  width: 100%;
  padding: 16px;
  border: 1px solid #d1d9e2;
  border-radius: 8px;
}

.footer-buttons {
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-primary {
  background-color: #247fec;
  color: #ffffff;
}

.btn-primary:hover {
  background-color: #1a5db8;
}

.btn-secondary {
  background-color: #ffffff;
  color: #2e3646;
  border: 1px solid #d1d9e2;
}

.btn-secondary:hover {
  background-color: #f8f9fa;
}

.rent-date {
  font-size: 1rem;
}

@media (max-width: 768px) {
  .header-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .toggle-switch {
    width: 100%;
  }
}

.border-b-none {
  border-bottom: none !important;
}

.blue-info-box {
  color: #1d54b0;
  background-color: #eff8ff;
  border: 1px solid #92d4fe;
  padding: 12px;
  border-radius: 8px;
  font-size: 14px;
  display: flex;
  gap: 12px;
}

.blue-info-box p {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/RentAdjustment/FormTabs/Detail/DetailFormStep/ChooseUnit/ChooseUnit.vue